(function() {
  var gtcBtn = document.getElementById('wattec-gotocart');
  if (!gtcBtn) return;

  var drawerOpen = false;

  function setActiveState(active) {
    drawerOpen = active;
    if (active) {
      gtcBtn.classList.add('wattec-gtc-active');
    } else {
      gtcBtn.classList.remove('wattec-gtc-active');
    }
  }

  function openCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      setActiveState(true);
    } else {
      var cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) cartIconBubble.click();
      setActiveState(true);
    }
  }

  function closeCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.close === 'function') {
      cartDrawer.close();
      setActiveState(false);
    } else {
      var closeBtn = document.querySelector(
        'cart-drawer button[class*="close"], ' +
        '#CartDrawer button[class*="close"], ' +
        '.cart-drawer__close, ' +
        '[id*="cart-drawer"] button[aria-label*="close" i], ' +
        '[id*="cart-drawer"] button[aria-label*="Close" i]'
      );
      if (closeBtn) { closeBtn.click(); setActiveState(false); }
    }
  }

  gtcBtn.addEventListener('click', function() {
    if (drawerOpen) {
      closeCartDrawer();
    } else {
      openCartDrawer();
    }
  });

  // Track drawer state via events
  document.addEventListener('cart:open', function() { setActiveState(true); });
  document.addEventListener('cart:drawer:open', function() { setActiveState(true); });
  document.addEventListener('cart:close', function() { setActiveState(false); });
  document.addEventListener('cart:drawer:close', function() { setActiveState(false); });

  // Also detect via DOM polling
  function isDrawerOpen() {
    var drawer = document.querySelector('cart-drawer, #CartDrawer');
    if (!drawer) return false;
    return drawer.classList.contains('is-open') ||
           drawer.classList.contains('active') ||
           drawer.classList.contains('open') ||
           drawer.getAttribute('open') !== null;
  }

  // Sync active state with actual drawer DOM state
  setInterval(function() {
    var open = isDrawerOpen();
    if (open !== drawerOpen) setActiveState(open);
  }, 300);

  /* Whether to show the button, decided from a cart (see below). On a
     product page it stays hidden while the floating bar already says this
     exact selection is in the cart. */
  function applyCart(cart) {
    var hasItems = !!(cart && cart.items && cart.items.length > 0);
    var show = hasItems;
    if (hasItems && document.querySelector('form[action="/cart/add"]')) {
      var wattecBtn = document.getElementById('wattec-btn');
      if (wattecBtn && wattecBtn.textContent.trim().indexOf('✓ In Cart') === 0) show = false;
    }
    gtcBtn.classList.toggle('wattec-gtc-visible', show);
  }

  /* Reading the cart. Shopify answers one visitor's cart requests one at a
     time, so a flood of them queues up and every answer arrives late — which
     is what made this button (and the floating bar's "In Cart") slow to
     appear. So:
       - a cart the floating bar fetched in the last couple of seconds is
         used as it is (the bar shares it as window.wattecLastCart and a
         "wattec:cart" event) instead of asking again;
       - only one request is ever in flight, and bursts of triggers are
         merged into one. */
  var fetching = false;
  var fetchStarted = 0;
  var again = false;
  var timer = null;
  var seqSent = 0;
  var seqApplied = 0;

  function checkCartForGtc() {
    var shared = window.wattecLastCart;
    if (shared && Date.now() - shared.at < 2500) {
      applyCart(shared.cart);
      return;
    }
    // One at a time, but a request that hasn't answered within 4 seconds
    // never holds the next one up; an older answer never overwrites a newer.
    if (fetching && Date.now() - fetchStarted < 4000) { again = true; return; }
    fetching = true;
    fetchStarted = Date.now();
    var seq = ++seqSent;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (seq < seqApplied) return;
        seqApplied = seq;
        applyCart(cart);
      })
      .catch(function() {})
      .then(function() {
        if (seq !== seqSent) return;
        fetching = false;
        if (again) { again = false; scheduleCheck(250); }
      });
  }

  // The moment any add-to-cart (or cart change) finishes, whichever button
  // or app sent it, a short run of looks follows (Shopify can take a moment
  // to include the new item in its answer).
  var afterTimers = [];
  function afterCartChange() {
    window.wattecLastCart = null;
    afterTimers.forEach(clearTimeout);
    afterTimers = [200, 800, 1800, 3500].map(function(d) { return setTimeout(checkCartForGtc, d); });
  }
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function(list) {
        list.getEntries().forEach(function(entry) {
          if (/[/]cart[/](add|change|update|clear)/.test(entry.name)) afterCartChange();
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) { /* older browser: the regular look below still covers it */ }
  }

  function scheduleCheck(delay) {
    clearTimeout(timer);
    timer = setTimeout(checkCartForGtc, delay == null ? 150 : delay);
  }

  // The floating bar's own cart reads, as they arrive.
  document.addEventListener('wattec:cart', function(e) { applyCart(e.detail); });

  function attachWattecObserver() {
    var wattecBtn = document.getElementById('wattec-btn');
    if (wattecBtn) {
      var lastLabel = wattecBtn.textContent;
      new MutationObserver(function() {
        // Only a real change of wording ("Add to Cart" / "In Cart") matters.
        if (wattecBtn.textContent === lastLabel) return;
        lastLabel = wattecBtn.textContent;
        scheduleCheck(100);
      }).observe(wattecBtn, { childList: true, characterData: true, subtree: true });
    } else {
      setTimeout(attachWattecObserver, 1000);
    }
  }

  checkCartForGtc();
  attachWattecObserver();
  setInterval(checkCartForGtc, 2500);

  ['cart:updated', 'cart:refresh', 'cartUpdate', 'cart:close', 'cart:drawer:close'].forEach(function(evt) {
    document.addEventListener(evt, function() { window.wattecLastCart = null; scheduleCheck(300); });
  });

})();
